import type { HelpKind } from "./generated/HelpKind";
import type { Locale } from "./generated/Locale";

// Help buttons on the exercise card (ADR-0044). A tap sends Coach one of these fixed
// sentences, in the child's voice, as if the child had typed it. One copy for both ends:
// the actor sends it to Coach, the app shows it at once in the conversation (offline too).

const HELP_PHRASES: Record<HelpKind, Record<Locale, string>> = {
  rephrase: {
    en: "I don't understand the question. Can you say it another way?",
    fr: "Je ne comprends pas la question. Tu peux me l'expliquer autrement ?",
  },
  clue: {
    en: "Can I have a clue?",
    fr: "Tu peux me donner un indice ?",
  },
  method: {
    en: "How do I go about it?",
    fr: "Comment je m'y prends ?",
  },
  example: {
    en: "Can you show me a similar example?",
    fr: "Tu peux me montrer un exemple du même genre ?",
  },
};

/** The sentence a help button sends to Coach. */
export function helpPhrase(kind: HelpKind, locale: Locale): string {
  return HELP_PHRASES[kind][locale];
}
